// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-bs-table-del-btn{padding:6px 30px !important;font-size:1rem !important}.react-bs-table-tool-bar{margin-bottom:15px}.form-control{font-size:inherit}.devicesList__addButton{position:absolute;top:0;left:130px}.devicesList__table td{white-space:unset !important}.react-bs-table-bordered{background-color:#fff}", ""]);
// Exports
module.exports = exports;
